import { useTranslation } from 'react-i18next';
import { faClock } from '@fortawesome/pro-regular-svg-icons/faClock';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Flex, theme, Typography } from 'antd';
import { useJobSlotStartAndEndDisplayTimes } from 'pos-client/components/scheduleBoard/hooks/useJobSlotStartAndEndDisplayTimes.ts';
import { useJobStatusTextColor } from 'pos-client/components/scheduleBoard/hooks/useJobStatusTextColor.ts';
import { PosLabel } from 'pos-client/components/shared/Form/PosLabel.tsx';
import type { ScheduleBoardBlockedSlotModel } from 'pos-shared/models/schedulingSchema.ts';

import { JobStatusIcon } from './JobStatusIcon.tsx';

interface BlockedSlotContentProps {
  slotData: ScheduleBoardBlockedSlotModel;
}

export const BlockedSlotContent = ({ slotData }: BlockedSlotContentProps) => {
  const { token } = theme.useToken();

  const { t } = useTranslation();

  const textColor = useJobStatusTextColor(slotData.state);
  const { startDisplay, endDisplay } = useJobSlotStartAndEndDisplayTimes(
    slotData.startDateDisplay,
    slotData.endDateDisplay,
    false
  );

  const warningIcon =
    slotData.state === 'Unauthorized' ? (
      <JobStatusIcon status={'unauthorized-warning'} />
    ) : (
      ''
    );

  return (
    <Col style={{ color: textColor, fontSize: token.fontSizeSM }}>
      <Flex justify="space-between" align="center">
        <Typography.Text
          style={{ fontWeight: token.fontWeightStrong, marginBottom: 0 }}
        >
          {`${slotData.state} ${t('scheduling.blockedSlot.blocked')} `}
          {warningIcon}
        </Typography.Text>
        <JobStatusIcon status={slotData.state} />
      </Flex>

      <Flex
        align="center"
        style={{
          marginTop: token.marginXXS,
          marginBottom: token.marginXXS,
        }}
      >
        <FontAwesomeIcon
          icon={faClock}
          style={{ fontSize: token.fontSizeSM, marginRight: token.marginXS }}
        />
        <span>{`${startDisplay} - ${endDisplay}`}</span>
      </Flex>

      <PosLabel boldLabel label={t('scheduling.blockedSlot.reason')} />
      <Typography.Text
        id="blocked-slot-description"
        style={{
          WebkitLineClamp: 4,
          WebkitBoxOrient: 'vertical',
          display: '-webkit-box',
          textWrap: 'wrap',
          margin: 0,
          textOverflow: 'ellipsis',
          overflow: 'hidden',
        }}
      >
        {slotData.description}
      </Typography.Text>
    </Col>
  );
};
